<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <!-- <div class="col-sm-6">
            <h1>Billing Payment/History</h1>
          </div> -->
          <div class="col-sm-6 d-none">
            <ol class="breadcrumb">
              <li class="breadcrumb-item">
                <router-link :to="{ name: 'dashboard' }">Home</router-link>
              </li>
              <li class="breadcrumb-item active">Service Status</li>
            </ol>
          </div>
        </div>
      </div>
    </section>

    <!-- Main content -->
    <section class="content">
      <div class="container-fluid">
        <div class="row justify-content-center">
          <div class="col-md-6">
            <div class="card">
              <div class="card-header">
                <h3 class="card-title d-flex align-items-center">
                  Package <span>{{ packageInfo.package.toLowerCase() }}</span>
                </h3>
                <span class="connection-status">
                  {{ packageInfo.subscriberStatus }}
                </span>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-6">
                    <div class="average-speed">
                      <img
                        src="../../../public/assets/images/icon-download.svg"
                        alt="upgrade"
                      />

                      <h2 class="heading">
                        {{ packageInfo.downloadSpeed }} MB
                      </h2>
                      <p class="mb-0 mb-md-2">Average speed</p>
                      <div class="average-speed-btn">
                        <button class="btn" type="button">Download</button>
                      </div>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="average-speed">
                      <img
                        src="../../../public/assets/images/icon-upload.svg"
                        alt="upgrade"
                      />
                      <h2 class="heading">{{ packageInfo.uploadSpeed }} MB</h2>
                      <p class="mb-0 mb-md-2">Average speed</p>
                      <div class="average-speed-btn">
                        <button class="btn" type="button">Upload</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- /.content -->
  </div>
</template>
<style>
.package-box {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 10px;
  margin-top: 10px;
}
.package-box span.my-package {
  line-height: 1.2;
  font-weight: 300;
  margin-left: 20px;
  width: 120px;
  background-color: lightgray;
  height: 32px;
  border-radius: 25px;
  margin-top: auto;
  padding-top: 5px;
  font-size: 18px;
}
.connection-status {
  font-weight: 600;
  font-size: 16px;
  color: #1abc9c;
  border-radius: 30px;
  background: #eaf5f3;
  padding: 5px 15px;
}
.card-title span {
  background: linear-gradient(90deg, #5e3f8f 0%, #f24975 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  display: inline-flex;
  margin-left: 10px;
  font-weight: 700;
  text-transform: capitalize;
}
</style>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "AccountView",
  metaInfo: {
    title: "My Information | Dotlines",
  },
  components: {
    //
  },

  data: () => ({
    params: {},
    value: {},
    is_loading: false,
  }),

  mounted: function () {
    if (this.isMobile()) {
      var openOrClose = window.$(document).find(".sidebar-mini");
      if ($(openOrClose).hasClass("sidebar-open")) {
        window.$(document).find(".push-menu-class").trigger("click");
      }
    }

    // let _this = this;
    // _this.param = _this.$route.params;
  },

  computed: {
    ...mapGetters(["profile", "packageInfo"]),
  },

  methods: {
    ...mapActions(["FETCH_PROFILE", "FETCH_PACKAGE_INFO"]),
  },
};
</script>
